



import DiscountCouponForm from '../../features/commonfile/DiscountCouponForm'

const MarketingManagerCouponCode = () => {
    return (
        <DiscountCouponForm />
    )
}

export default MarketingManagerCouponCode